import { useContext } from 'react';
import { LocaleActions, LocaleState } from '../context';
export const useLocaleActions = () => useContext(LocaleActions);
export const useLocaleState = () => useContext(LocaleState);
export const useLocale = () => [
    useLocaleState(),
    useLocaleActions(),
];
